import { CheckmarkOrb } from '@clearkit/icons';
import { CKBannerNext, CKLayoutGridAuto, CKLayoutVertical } from 'clearkit';

import { useCreditUsage } from '~/hooks/account/useCreditUsage';

import { routes } from '../app/appMainRoutes';
import { BusinessPlan, FreePlan, GrowthPlan } from '../PlanColumns';

const PlansAndBilling = () => {
  const { isHubspotAccount, isPaidAccount, credits } = useCreditUsage();

  return (
    <>
      {isPaidAccount ? (
        <CKBannerNext className="mx-10 mb-8">
          <CKBannerNext.IconStatus>
            <CheckmarkOrb />
          </CKBannerNext.IconStatus>
          <CKBannerNext.Body>
            <CKLayoutVertical as="span" gap="0">
              <span className="font-semibold text-gray-900">
                Your team has been upgraded to the Growth plan
              </span>
              <span className="text-gray-500">
                {credits} credits available per month, refreshed monthly
              </span>
            </CKLayoutVertical>
          </CKBannerNext.Body>
        </CKBannerNext>
      ) : null}
      <CKLayoutGridAuto
        className="px-10 pt-1 mb-8"
        gapColumn="2rem"
        gapRow="4rem"
        minWidth="15rem"
      >
        <FreePlan />
        <GrowthPlan url={routes.plansUpgrade} />
        {!isHubspotAccount ? <BusinessPlan /> : null}
      </CKLayoutGridAuto>
    </>
  );
};

export default PlansAndBilling;
